import React, { FC } from 'react'

import SpaceForm from '../molecules/SpaceForm'
import MainLayout from '../../Layouts/MainLayout'
const SpaceFormPage:FC =()=>{
   return (
    <>  
     <MainLayout>
      <SpaceForm/>
     </MainLayout>
    </>
   )
}
export default SpaceFormPage